export var FlightOps;
(function (FlightOps) {
    FlightOps["ATO_NCC"] = "ATO/NCC";
    FlightOps["ATO_NCO"] = "ATO/NCO";
    FlightOps["CAT"] = "CAT";
    FlightOps["NCC"] = "NCC";
    FlightOps["NCO"] = "NCO";
    FlightOps["SPO"] = "SPO";
})(FlightOps || (FlightOps = {}));
export const getAllFlightOpsTypes = () => [
    FlightOps.CAT,
    FlightOps.ATO_NCC,
    FlightOps.ATO_NCO,
    FlightOps.NCC,
    FlightOps.NCO,
    FlightOps.SPO,
];
export const stringIsOps = (maybeOps) => {
    return getAllFlightOpsTypes().includes(maybeOps);
};
export const isOpsAto = (ops) => ops === FlightOps.ATO_NCO || ops === FlightOps.ATO_NCC;
export function isOpsCommercial(ops) {
    return isOpsAto(ops) || ops === FlightOps.CAT;
}
export function isOpsCommercialOrComplex(ops) {
    return isOpsCommercial(ops) || ops === FlightOps.NCC;
}
export function isOpsCatOrComplex(ops) {
    return ops === FlightOps.CAT || ops === FlightOps.NCC;
}
export const flightOpsLabels = new Map([
    [FlightOps.ATO_NCC, 'ATO/NCC'],
    [FlightOps.ATO_NCO, 'ATO/NCO'],
    [FlightOps.CAT, 'CAT'],
    [FlightOps.NCC, 'NCC'],
    [FlightOps.NCO, 'NCO'],
    [FlightOps.SPO, 'SPO'],
]);
//# sourceMappingURL=FlightOpsTypes.js.map